import React, { useState } from "react";
import "./RedefinirSenha.css";
import { useParams, useNavigate } from "react-router-dom";

import axios, { BASE_URL } from "../axiosConfig";

import { validarSenhaFrontend } from "../utils/senhaUtils";

const getImagemUrl = (img) => {
  if (!img) return "";

  // Se começar com http://localhost:xxxx, substitui pela BASE_URL
  if (img.startsWith("http://localhost:3001")) {
    return img.replace("http://localhost:3001", BASE_URL);
  }

  // Para qualquer http://localhost:<porta>
  if (/^http:\/\/localhost:\d+/.test(img)) {
    return img.replace(/^http:\/\/localhost:\d+/, BASE_URL);
  }

  // Se for caminho relativo
  return img.startsWith("http") ? img : `${BASE_URL}${img}`;
};

function RedefinirSenha() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [novaSenha, setNovaSenha] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [erro, setErro] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validacaoSenha = validarSenhaFrontend(novaSenha);

    if (!validacaoSenha.valida) {
      setErro(validacaoSenha.mensagem);
      setMensagem("");
      return;
    }

    try {
      const response = await axios.post(`/redefinir-senha/${token}`, {
        novaSenha
      });

      setMensagem(response.data.message);
      setErro("");

      setTimeout(() => navigate("/login"), 3000);

    } catch (error) {
      if (error.response?.data?.error) {
        setErro(error.response.data.error);
      } else {
        setErro("Erro ao conectar com o servidor.");
      }

      setMensagem("");
    }
  };

  return (
    <div
      className="reset-wrapper"
      style={{
        backgroundImage: `url('${BASE_URL}/uploads/bg-login.jpg')`,

        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className="reset-card">
      <img src={getImagemUrl("/uploads/tikpontos.png")} alt="Logo" className="logo-reset" />


        <h2>Redefinir Senha</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="Digite a nova senha"
            value={novaSenha}
            onChange={(e) => setNovaSenha(e.target.value)}
            autoComplete="new-password"
            minLength={8}
            required
          />
          <small>
            Use pelo menos 8 caracteres, incluindo letras e números.
          </small>
          <button type="submit">Salvar nova senha</button>
        </form>
        {mensagem && <p className="sucesso">{mensagem}</p>}
        {erro && <p className="erro">{erro}</p>}
      </div>
    </div>
  );
}

export default RedefinirSenha;